module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('input', {
    ref: "idImgFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".jpg,.png"
    },
    on: {
      "change": _vm.onImgChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "6px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("选择文件")))]), _vm._v(" "), _c('div', {
    ref: "idImgPath",
    staticStyle: {
      "float": "left",
      "margin-top": "7px",
      "text-indent": "10px",
      "width": "350px",
      "height": "30px",
      "line-height": "30px",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "252px",
      "height": "252px",
      "margin-top": "10px",
      "background": "#bbbbbb",
      "border": "1px solid #bbbbbb",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_c('img', {
    ref: "idImgPan",
    staticStyle: {
      "float": "left",
      "border": "0px solid red"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('模板名称')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templaName),
      expression: "templaName"
    }],
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.templaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templaName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("保存")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e560b234","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/thumupd.vue
// module id = 796
// module chunks = 1